<template>
  <div class="login-page">
    <div class="login-form-container">
      <div class="fiflbox-logo" />
      <el-form
        class="login-form"
        :model="form"
        :rules="formValidateRules"
        label-position="top"
        label-width="100px"
        @validate="handleValidateChange"
      >
        <el-form-item
          label="이메일"
          prop="username"
        >
          <el-input
            v-model="form.username"
            data-test="input-username"
            type="email"
            placeholder="정확한 이메일을 입력해주세요"
            auto-complete="off"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="비밀번호"
          prop="password"
        >
          <el-input
            v-model="form.password"
            data-test="input-password"
            class="login-form__input-password"
            type="password"
            placeholder="비밀번호를 입력해주세요"
            auto-complete="off"
            clearable
            @keydown.enter="handleClickLogin"
          />
        </el-form-item>
        <el-button
          class="default"
          data-test="button-login"
          :disabled="!isLoginActive"
          :loading="isLoginLoading"
          @click="handleClickLogin"
        >
          로그인
        </el-button>
        <div class="login-other-links">
          <router-link to="/register">
            회원가입
          </router-link> |
          <router-link to="/password/identify">
            비밀번호 재설정
          </router-link>
        </div>
      </el-form>
      <section class="guide-container">
        <p>센터를 다니고 있는 회원이신가요?</p>
        <a
          href="#"
          @click="hadleMovePage"
        >
          피플박스 앱으로 이동
        </a>
      </section>
    </div>
  </div>
</template>

<script>
import { fiflboxApi } from '@/utils/api';
import { computedGetters } from '@/utils/vuex-helper';
import { validateEmailOnLogin } from '@/utils/form-validate-rules';

export default {
  name: 'LoginPage',
  data() {
    return {
      isLoginComplete: false,
      isLoginActive: false,
      isLoginLoading: false,
      form: {
        username: '',
        password: ''
      },
      formValidateRules: {
        username: [{ validator: validateEmailOnLogin, trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...computedGetters([
      'role',
      'instructorToken',
      'instructorDefaultPage',
      'isOwnerAccount'
    ])
  },
  watch: {
    isLoginComplete(result) {
      if (result) {
        this.redirectToDefaultPage();
      }
    }
  },
  async mounted() {
    if (this.$tokenStorage.hasToken()) {
      let bearerToken = this.$tokenStorage.getBearerToken();
      fiflboxApi.default.setHeadersAuthorization(bearerToken);

      // 1. set role
      await this.$store.commit('setIsOwnerAccount', this.role);

      // 2. move to defalut page.
      this.redirectToDefaultPage();
    } else {
      try {
        await fiflboxApi.v1.postAccountsLogout();
      } catch (err) {
        console.log(err);
      }
      await this.$store.dispatch('timeTable/resetTimeTableInfos');
      await this.$tokenStorage.deleteToken();
    }

    document
      .querySelector('.login-form__input-password > input')
      .addEventListener('keypress', event => {
        if (13 == event.keyCode) {
          this.handleClickLogin();
        }
      });
  },
  methods: {
    hadleMovePage() {
      const userAgent = navigator.userAgent.toLowerCase();
      const appleStoreUrl =
        'https://apps.apple.com/kr/app/%ED%94%BC%ED%94%8C%EB%B0%95%EC%8A%A4-fiflbox/id1280806109';
      const playStoreUrl =
        'https://play.google.com/store/apps/details?id=com.fifl.fiflbox&hl=ko';
      const redirectUrl =
        userAgent.indexOf('mac') > -1 ? appleStoreUrl : playStoreUrl;
      window.open(redirectUrl);
    },
    handleValidateChange($event, isValidated) {
      this.isLoginActive = isValidated;
    },
    async login() {
      let loginResult;

      try {
        let { data } = await fiflboxApi.v2.postLogin(
          {},
          {
            auth: this.form
          }
        );
        loginResult = data;
      } catch (err) {
        if (err.response) {
          throw err.response.data;
        }
        throw {
          error_code: '404',
          error_detail:
            '서버와의 연결이 원활하지 않습니다. 네트워크 연결을 확인해주세요.'
        };
      }
      this.$store.commit('setRole', loginResult.role);
      this.$store.commit('setIsOwnerAccount', loginResult.role);
      this.$store.commit('setInstructorToken', loginResult.instructor_token);
      let token = loginResult.token;

      this.$tokenStorage.setToken(token);

      let bearerToken = this.$tokenStorage.getBearerToken();

      fiflboxApi.default.setHeadersAuthorization(bearerToken);
    },
    async handleClickLogin() {
      if (this.isLoginActive) {
        this.isLoginLoading = true;
        try {
          await this.login();
          this.isLoginComplete = true;
        } catch (err) {
          this.isLoginLoading = false;
          return this.$alert(err.error_detail, '로그인 실패', {
            confirmButtonText: '확인',
            showClose: false,
            customClass: 'fifl-message-box',
            confirmButtonClass: 'gray'
          });
        }
      }
    },
    async redirectToDefaultPage() {
      if (this.isOwnerAccount) {
        this.$router.push('/dashboard').catch(() => {});
      } else {
        await this.$store.dispatch('syncInstructorAccessAuthByToken');
        await this.$store.dispatch('syncInstructorDefaultPage');
        await this.$store.dispatch('syncAccountAccessAuth');
        this.$router.push(this.instructorDefaultPage).catch(() => {});
      }
    }
  }
};
</script>

<style lang="scss">
.login-page {
  height: 100%;
}

.login-form-container {
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 15vh;
  width: 350px;

  .login-form {
    margin-top: 50px;

    input {
      -webkit-ime-mode: inactive;
      -moz-ime-mode: inactive;
      -ms-ime-mode: inactive;
      ime-mode: inactive;
    }
  }

  .login-other-links {
    margin-top: 20px;
    height: 33px;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: -0.8px;
    text-align: center;
    color: #d3d3d3;

    a {
      line-height: 33px;
      display: inline-block;
      width: calc(50% - 10px);
      text-decoration: none;
      color: #7a7a7a;
      font-size: 13px;
      letter-spacing: -0.8px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.guide-container {
  margin-top: 30px;
  text-align: center;
  p,
  a {
    margin: 0 auto;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.54;
    letter-spacing: -0.8px;
    color: #9b9b9b;
  }

  a {
    cursor: pointer;
    text-decoration: underline;
  }
}

@media screen and (max-width: 768px) {
  .login-form-container {
    width: 100%;
    padding: 50px 40px;
    margin: 0;
    .login-form {
      margin-top: 30px;
    }
  }
}
</style>
